import { EllipsisVertical } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

interface Action {
    label: string
    icon?: JSX.Element
    action: () => void
}


type DrowpdownMenuProps = {
    actions?: Action[] 
}

const DrowpdownMenu = ({
    actions
}: DrowpdownMenuProps) => {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button 
                    size="icon"
                    variant={'ghost'}
                >
                    <span className="sr-only">Open menu</span>
                    <EllipsisVertical className="w-4 h-4 text-foreground" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="border-none" align="end">
                <DropdownMenuLabel className="py-1 text-neutral-200">
                    Ações
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                {actions &&
                    actions.map((action, index) => (
                        <DropdownMenuItem
                            key={index}
                            className="gap-2 text-neutral-200"
                            onClick={action.action}
                        >
                            {action.icon}
                            {action.label}
                        </DropdownMenuItem>
                    ))}
            </DropdownMenuContent>
        </DropdownMenu>
    )
}

export default DrowpdownMenu
